import axios from 'core/network/interceptor';
import { PostLoginUrl } from './constants';

const PostLoginRequest = async (data: {email: string, password: string}) => {
    const response = await axios.post(PostLoginUrl, data);

    return response.data;
};

export { PostLoginRequest };